import React from 'react';
import AnalyticsPageLayout from '../components/analytics/AnalyticsPageLayout';
import SponsoredCohortModuleProgressAnalytics from '../components/SponsoredCohortModuleProgressAnalytics';
import SponsoredCohortModuleProgressRawData from '../components/SponsoredCohortModuleProgressRawData';
import SponsoredCohortWeekCompletionRawData from '../components/SponsoredCohortWeekCompletionRawData';

const TABS = [
  {
    title: 'Module progress analytics',
    component: <SponsoredCohortModuleProgressAnalytics />,
  },
  {
    title: 'Module progress raw data',
    component: <SponsoredCohortModuleProgressRawData />,
  },
  {
    title: 'Week completion raw data',
    component: <SponsoredCohortWeekCompletionRawData />,
  },
];

export default function CohortModuleProgressAnalytics() {
  return (
    <AnalyticsPageLayout
      title="Sponsored Cohort Module Progress"
      description="Learner progression across modules and courses by sponsored cohort."
      tabs={TABS}
    />
  );
}
